import campaign from "@/http/requests/newsletter/campaign"

export default {
  fetch({ commit }, queryData) {
    return new Promise((resolve, reject) => {
      campaign.fetch(queryData).then(response => {
        commit('SET_CAMPAIGNS', response.data.data.newsletterCampaigns)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  add({ commit }, data) {
    return new Promise((resolve, reject) => {
      campaign.add(data).then(response => {
        commit('ADD_CAMPAIGN', response.data.data.createNewsletterCampaigns)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  update({ commit }, data) {
    return new Promise((resolve, reject) => {
      campaign.update(data).then(response => {
        commit('UPDATE_CAMPAIGN', response.data.data.updateNewsletterCampaigns)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  delete({ commit }, campaignId) {
    return new Promise((resolve, reject) => {
      campaign.delete(campaignId).then(response => {
        commit('DELETE_CAMPAIGN', campaignId)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  infos({ commit }, campaignId) {
    return new Promise((resolve, reject) => {
      campaign.infos(campaignId).then(response => {
        commit('ADD_CAMPAIGN_INFOS', response.data.data.newsletterCampaignInfos)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  test(_, { campaignId, testEmails }) {
    return new Promise((resolve, reject) => {
      campaign.test(campaignId, testEmails).then(response => {
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  send(_, campaignId) {
    return new Promise((resolve, reject) => {
      campaign.send(campaignId).then(response => {
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  }
}
